export enum IncidentImpactEnum {
  Emergency,
  Critical,
  High,
  Medium,
  Low,
}
